(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tz-find-the-right-gaming-pc"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ── Worker proxy URL ── */
    /* After deploying cloudflare-worker/zendesk-proxy.js, replace the value below
       with your Worker URL, e.g. https://tz-zendesk-proxy.YOUR-SUBDOMAIN.workers.dev */
    var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

    /* ── DOM refs ── */
    var form = document.getElementById('tz_frgp_form');
    var firstNameEl = document.getElementById('tz_frgp_first_name');
    var lastNameEl = document.getElementById('tz_frgp_last_name');
    var emailEl = document.getElementById('tz_frgp_email');
    var phoneEl = document.getElementById('tz_frgp_phone');
    var countryEl = document.getElementById('tz_frgp_country');
    var budgetEl = document.getElementById('tz_frgp_budget');
    var messageEl = document.getElementById('tz_frgp_message');
    var submitBtn = document.getElementById('tz_frgp_submit_btn');
    var bannerSurface = document.getElementById('tz_frgp_banner_surface');
    var banner = document.getElementById('tz_frgp_banner');
    var bannerIconWrap = document.getElementById('tz_frgp_banner_icon_wrap');
    var bannerTag = document.getElementById('tz_frgp_banner_tag');
    var bannerTitle = document.getElementById('tz_frgp_banner_title');
    var bannerSubtitle = document.getElementById('tz_frgp_banner_subtitle');
    var bannerProgress = document.getElementById('tz_frgp_banner_progress');
    var bannerCloseBtn = banner ? banner.querySelector('.tz-frgp-banner-close-btn') : null;

    if (!form) return;

    /* ── SVG icons ── */
    var ICON_SUCCESS =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ICON_ERROR =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var ICON_INFO =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

    /* ── Banner config ── */
    var BANNER_CONFIG = {
      success: {
        tagText: 'Enquiry sent',
        title: "We've got your details \u2014 let's find your perfect build!",
        subtitle: 'One of our gaming PC specialists will review your enquiry and get back to you within 24 hours.',
        icon: ICON_SUCCESS,
        showProgress: true,
      },
      error: {
        tagText: 'Submission failed',
        title: 'Something went wrong \u2014 please try again.',
        subtitle:
          'Your enquiry could not be sent. Check your details and try again, or contact us directly if the issue persists.',
        icon: ICON_ERROR,
        showProgress: false,
      },
      info: {
        tagText: 'Processing\u2026',
        title: 'Sending your enquiry',
        subtitle: 'Please hold on, this only takes a moment.',
        icon: ICON_INFO,
        showProgress: false,
      },
    };

    /* ── Show banner ── */
    function showBanner(type) {
      var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;

      banner.className = 'tz-frgp-banner tz-frgp-banner-' + type;
      bannerIconWrap.className = 'tz-frgp-banner-icon-wrap';
      bannerIconWrap.innerHTML = cfg.icon;
      bannerTag.className = 'tz-frgp-banner-tag';
      bannerTag.textContent = cfg.tagText;
      bannerTitle.textContent = cfg.title;
      bannerSubtitle.textContent = cfg.subtitle;

      if (cfg.showProgress) {
        bannerProgress.style.display = '';
        var fill = bannerProgress.querySelector('.tz-frgp-banner-progress-fill');
        var clone = fill.cloneNode(true);
        fill.parentNode.replaceChild(clone, fill);
        setTimeout(function () {
          banner.classList.add('tz-frgp-banner-animate');
        }, 20);
      } else {
        bannerProgress.style.display = 'none';
        banner.classList.remove('tz-frgp-banner-animate');
      }

      bannerSurface.classList.add('tz-frgp-banner-visible');
      bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ── Hide banner ── */
    function clearBanner() {
      bannerSurface.classList.remove('tz-frgp-banner-visible');
      banner.classList.remove('tz-frgp-banner-animate');
    }

    if (bannerCloseBtn) {
      bannerCloseBtn.addEventListener('click', clearBanner);
    }

    /* ── Button busy state ── */
    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitBtn.textContent = busy ? 'Please wait\u2026' : 'Send';
    }

    /* ── Input error helpers ── */
    function markError(el) {
      el.classList.add('tz-frgp-input-error');
    }
    function clearErrors() {
      [firstNameEl, emailEl, budgetEl].forEach(function (el) {
        if (el) el.classList.remove('tz-frgp-input-error');
      });
    }

    /* ── Email format check ── */
    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
    }

    /* ── Validation ── */
    function validate() {
      clearErrors();

      if (!firstNameEl.value.trim()) {
        markError(firstNameEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your first name so our team knows who to contact.';
        showBanner('error');
        firstNameEl.focus();
        return false;
      }

      var email = emailEl.value.trim();
      if (!email) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your email address so we can send you a recommendation.';
        showBanner('error');
        emailEl.focus();
        return false;
      }

      if (!isValidEmail(email)) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle =
          'That doesn\u2019t look like a valid email address. Please double-check and try again.';
        showBanner('error');
        emailEl.focus();
        return false;
      }

      /* ── Budget check ── */
      if (budgetEl && !budgetEl.value.trim()) {
        markError(budgetEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your budget so we can recommend the right build for you.';
        showBanner('error');
        budgetEl.focus();
        return false;
      }

      /* ── Turnstile token check ── */
      var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
      if (!turnstileToken || !turnstileToken.value) {
        BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
        showBanner('error');
        return false;
      }

      return true;
    }

    /* ── Reset Turnstile widget ── */
    function resetTurnstile() {
      if (window.turnstile) {
        var widgetEl = document.getElementById('tz_frgp_turnstile');
        if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
          window.turnstile.reset(widgetEl._turnstileWidgetId);
        } else {
          window.turnstile.reset();
        }
      }
    }

    /* ── Submit to Worker proxy (avoids CORS) ── */
    function submitToWorker(payload) {
      return fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || ('HTTP ' + res.status));
          return data;
        });
      });
    }

    /* ── Main submit handler ── */
    function handleSubmit(e) {
      e.preventDefault();
      clearBanner();

      if (!validate()) return;

      setBusy(true);
      showBanner('info');

      var firstName = firstNameEl.value.trim();
      var lastName  = lastNameEl  ? lastNameEl.value.trim()  : '';
      var fullName  = (firstName + ' ' + lastName).trim();
      var email     = emailEl.value.trim();
      var dialCode  = countryEl ? countryEl.value : '';
      var phone     = phoneEl   ? phoneEl.value.trim() : '';
      var fullPhone = dialCode && phone ? dialCode + ' ' + phone : phone || 'Not provided';
      var budget    = budgetEl  ? budgetEl.value.trim()  : '';
      var message   = messageEl ? messageEl.value.trim() : '';
      var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';

      submitToWorker({
        email:          email,
        name:           fullName,
        tag:            'find-the-right-gaming-pc',
        subject:        'Gaming PC Enquiry \u2013 ' + fullName,
        turnstileToken: turnstileToken,
        fields: [
          { label: 'Name',    value: fullName                                           },
          { label: 'Email',   value: email                                              },
          { label: 'Phone',   value: fullPhone                                          },
          { label: 'Budget',  value: budget ? '\u00a3' + budget : 'Not specified'       },
          { label: 'Message', value: message || 'No additional message provided.'       },
        ],
      })
        .then(function (res) {
          setBusy(false);
          if (res.success) {
            BANNER_CONFIG.error.subtitle =
              'Your enquiry could not be sent. Check your details and try again, or contact us directly if the issue persists.';
            showBanner('success');
            form.reset();
            resetTurnstile();
          } else {
            throw new Error(res.error || 'Unexpected response');
          }
        })
        .catch(function (err) {
          setBusy(false);
          BANNER_CONFIG.error.subtitle =
            'Your enquiry could not be submitted. Please try again in a moment or contact us directly.';
          showBanner('error');
          resetTurnstile();
          console.error('[TZ FRGP] Worker error:', err);
        });
    }

    /* ── Live clear on user correction ── */
    firstNameEl.addEventListener('input', function () {
      firstNameEl.classList.remove('tz-frgp-input-error');
      clearBanner();
    });
    emailEl.addEventListener('input', function () {
      emailEl.classList.remove('tz-frgp-input-error');
      clearBanner();
    });

    /* ── Phone: digits only ── */
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        var cleaned = phoneEl.value.replace(/\D/g, '');
        if (phoneEl.value !== cleaned) {
          var pos = phoneEl.selectionStart - (phoneEl.value.length - cleaned.length);
          phoneEl.value = cleaned;
          phoneEl.setSelectionRange(pos, pos);
        }
      });
    }

    /* ── Budget: digits only ── */
    if (budgetEl) {
      budgetEl.addEventListener('input', function () {
        var cleaned = budgetEl.value.replace(/\D/g, '');
        if (budgetEl.value !== cleaned) {
          var pos = budgetEl.selectionStart - (budgetEl.value.length - cleaned.length);
          budgetEl.value = cleaned;
          budgetEl.setSelectionRange(pos, pos);
        }
        budgetEl.classList.remove('tz-frgp-input-error');
        clearBanner();
      });
    }

    form.addEventListener('submit', handleSubmit);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tz-get-a-free-upgrade-quote"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ── Worker proxy URL ── */
  var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

  /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
  function submitToWorker(payload) {
    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    });
  }

  /* ── DOM refs ── */
  var form           = document.getElementById('tz_gafuq_form');
  var buyPcEl        = document.getElementById('tz_gafuq_buy_your_pc');
  var budgetEl       = document.getElementById('tz_gafuq_budget');
  var reasonEl       = document.getElementById('tz_gafuq_reason');
  var emailEl        = document.getElementById('tz_gafuq_email');
  var phoneEl        = document.getElementById('tz_gafuq_phone');
  var countryEl      = document.getElementById('tz_gafuq_country');
  var messageEl      = document.getElementById('tz_gafuq_message');
  var submitBtn      = document.getElementById('tz_gafuq_submit_btn');
  var bannerSurface  = document.getElementById('tz_gafuq_banner_surface');
  var banner         = document.getElementById('tz_gafuq_banner');
  var bannerIconWrap = document.getElementById('tz_gafuq_banner_icon_wrap');
  var bannerTag      = document.getElementById('tz_gafuq_banner_tag');
  var bannerTitle    = document.getElementById('tz_gafuq_banner_title');
  var bannerSubtitle = document.getElementById('tz_gafuq_banner_subtitle');
  var bannerProgress = document.getElementById('tz_gafuq_banner_progress');
  var bannerCloseBtn = banner ? banner.querySelector('.tz-gafuq-banner-close-btn') : null;

  if (!form) return;

  /* ── SVG icons ── */
  var ICON_SUCCESS = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_ERROR   = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_INFO    = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

  /* ── Banner config ── */
  var BANNER_CONFIG = {
    success: {
      tagText     : 'Quote requested',
      title       : "Your upgrade quote is on its way!",
      subtitle    : "Our upgrade specialists will review your details and send you a personalised quote within 24 hours. Get ready to level up your rig.",
      icon        : ICON_SUCCESS,
      showProgress: true
    },
    error: {
      tagText     : 'Submission failed',
      title       : 'Something went wrong \u2014 please try again.',
      subtitle    : 'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.',
      icon        : ICON_ERROR,
      showProgress: false
    },
    info: {
      tagText     : 'Processing\u2026',
      title       : 'Sending your upgrade request',
      subtitle    : 'Please hold on, this only takes a moment.',
      icon        : ICON_INFO,
      showProgress: false
    }
  };

  /* ── Show banner ── */
  function showBanner(type) {
    var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;

    banner.className           = 'tz-gafuq-banner tz-gafuq-banner-' + type;
    bannerIconWrap.className   = 'tz-gafuq-banner-icon-wrap';
    bannerIconWrap.innerHTML   = cfg.icon;
    bannerTag.className        = 'tz-gafuq-banner-tag';
    bannerTag.textContent      = cfg.tagText;
    bannerTitle.textContent    = cfg.title;
    bannerSubtitle.textContent = cfg.subtitle;

    if (cfg.showProgress) {
      bannerProgress.style.display = '';
      var fill  = bannerProgress.querySelector('.tz-gafuq-banner-progress-fill');
      var clone = fill.cloneNode(true);
      fill.parentNode.replaceChild(clone, fill);
      setTimeout(function () { banner.classList.add('tz-gafuq-banner-animate'); }, 20);
    } else {
      bannerProgress.style.display = 'none';
      banner.classList.remove('tz-gafuq-banner-animate');
    }

    bannerSurface.classList.add('tz-gafuq-banner-visible');
    bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ── Hide banner ── */
  function clearBanner() {
    bannerSurface.classList.remove('tz-gafuq-banner-visible');
    banner.classList.remove('tz-gafuq-banner-animate');
  }

  if (bannerCloseBtn) {
    bannerCloseBtn.addEventListener('click', clearBanner);
  }

  /* ── Button busy state ── */
  function setBusy(busy) {
    submitBtn.disabled    = busy;
    submitBtn.textContent = busy ? 'Please wait\u2026' : 'Get My Free Upgrade Quote';
  }

  /* ── Error helpers ── */
  function markError(el) { el.classList.add('tz-gafuq-input-error'); }
  function clearErrors() {
    [buyPcEl, budgetEl, reasonEl, emailEl, phoneEl].forEach(function (el) {
      if (el) el.classList.remove('tz-gafuq-input-error');
    });
  }

  /* ── Email format check ── */
  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  }

  /* ── Validation ── */
  function validate() {
    clearErrors();

    if (!buyPcEl.value) {
      markError(buyPcEl);
      BANNER_CONFIG.error.subtitle = 'Please let us know where you originally bought your PC.';
      showBanner('error');
      buyPcEl.focus();
      return false;
    }

    if (!budgetEl.value) {
      markError(budgetEl);
      BANNER_CONFIG.error.subtitle = 'Please select your budget range for the upgrade.';
      showBanner('error');
      budgetEl.focus();
      return false;
    }

    if (!reasonEl.value) {
      markError(reasonEl);
      BANNER_CONFIG.error.subtitle = 'Please tell us the main reason you want to upgrade your PC.';
      showBanner('error');
      reasonEl.focus();
      return false;
    }

    var email = emailEl.value.trim();
    if (!email) {
      markError(emailEl);
      BANNER_CONFIG.error.subtitle = 'Please enter your email address so we can send you the quote.';
      showBanner('error');
      emailEl.focus();
      return false;
    }

    if (!isValidEmail(email)) {
      markError(emailEl);
      BANNER_CONFIG.error.subtitle = "That doesn\u2019t look like a valid email address. Please double-check and try again.";
      showBanner('error');
      emailEl.focus();
      return false;
    }

    if (phoneEl && !phoneEl.value.trim()) {
      markError(phoneEl);
      BANNER_CONFIG.error.subtitle = 'Please enter your phone number so we can contact you about the quote.';
      showBanner('error');
      phoneEl.focus();
      return false;
    }

    /* ── Turnstile token check ── */
    var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
    if (!turnstileToken || !turnstileToken.value) {
      BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
      showBanner('error');
      return false;
    }

    return true;
  }

  /* ── Reset Turnstile widget ── */
  function resetTurnstile() {
    if (window.turnstile) {
      var widgetEl = document.getElementById('tz_gafuq_turnstile');
      if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
        window.turnstile.reset(widgetEl._turnstileWidgetId);
      } else {
        window.turnstile.reset();
      }
    }
  }

  /* ── Main submit handler ── */
  function handleSubmit(e) {
    e.preventDefault();
    clearBanner();

    if (!validate()) return;

    var email  = emailEl.value.trim();
    var buyPc  = buyPcEl.value;
    var budget = budgetEl.value;
    var reason = reasonEl.value;
    var dialCode  = countryEl ? countryEl.value : '';
    var phone     = phoneEl   ? phoneEl.value.trim() : '';
    var fullPhone = (dialCode && phone) ? dialCode + ' ' + phone : (phone || 'Not provided');
    var message   = messageEl ? messageEl.value.trim() : '';
    var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
    var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';

    setBusy(true);
    showBanner('info');

    submitToWorker({
      email:          email,
      name:           email.split('@')[0],
      tag:            'get-a-free-upgrade-quote',
      subject:        'Free Upgrade Quote \u2013 ' + email,
      turnstileToken: turnstileToken,
      fields: [
        { label: 'Email',             value: email    },
        { label: 'PC Purchase Place', value: buyPc    },
        { label: 'Upgrade Budget',    value: budget   },
        { label: 'Upgrade Reason',    value: reason   },
        { label: 'Phone',             value: fullPhone },
        { label: 'Message',           value: message || 'No additional message provided.' }
      ],
    })
      .then(function (res) {
        setBusy(false);
        if (res.success) {
          BANNER_CONFIG.error.subtitle = 'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.';
          showBanner('success');
          form.reset();
          resetTurnstile();
        } else {
          throw new Error(res.error || 'Unexpected response');
        }
      })
      .catch(function (err) {
        setBusy(false);
        BANNER_CONFIG.error.subtitle = 'Your upgrade quote request could not be submitted. Please try again or contact us directly.';
        showBanner('error');
        resetTurnstile();
        console.error('[TZ GAFUQ] Worker error:', err);
      });
  }

  /* ── Live clear on user correction ── */
  [buyPcEl, budgetEl, reasonEl].forEach(function (el) {
    el.addEventListener('change', function () {
      el.classList.remove('tz-gafuq-input-error');
      clearBanner();
    });
  });

  emailEl.addEventListener('input', function () {
    emailEl.classList.remove('tz-gafuq-input-error');
    clearBanner();
  });

  if (phoneEl) {
    phoneEl.addEventListener('input', function () {
      phoneEl.classList.remove('tz-gafuq-input-error');
      clearBanner();
    });
  }

  /* ── Phone: digits only ── */
  if (phoneEl) {
    phoneEl.addEventListener('input', function () {
      var cleaned = phoneEl.value.replace(/\D/g, '');
      if (phoneEl.value !== cleaned) {
        var pos = phoneEl.selectionStart - (phoneEl.value.length - cleaned.length);
        phoneEl.value = cleaned;
        phoneEl.setSelectionRange(pos, pos);
      }
    });
  }

  form.addEventListener('submit', handleSubmit);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tz-get-my-personalised-pc-build-form"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ── Worker proxy URL ── */
    var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

    /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
    function submitToWorker(payload) {
      return fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
          return data;
        });
      });
    }

    /* ── Main submit handler ── */
    function handleSubmit(e) {
      e.preventDefault();
      clearBanner();

      if (!validate()) return;

      var firstName = firstNameEl.value.trim();
      var lastName  = lastNameEl  ? lastNameEl.value.trim()  : '';
      var fullName  = (firstName + ' ' + lastName).trim();
      var email     = emailEl.value.trim();
      var dialCode  = countryEl ? countryEl.value : '';
      var phone     = phoneEl   ? phoneEl.value.trim() : '';
      var fullPhone = dialCode && phone ? dialCode + ' ' + phone : phone || 'Not provided';
      var message   = messageEl ? messageEl.value.trim() : '';
      var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';

      setBusy(true);
      showBanner('info');

      submitToWorker({
        email:          email,
        name:           fullName,
        tag:            'personalised-pc-build',
        subject:        'Personalised PC Build \u2013 ' + fullName,
        turnstileToken: turnstileToken,
        fields: [
          { label: 'Name',    value: fullName                                     },
          { label: 'Email',   value: email                                        },
          { label: 'Phone',   value: fullPhone                                    },
          { label: 'Message', value: message || 'No additional message provided.' },
        ],
      })
        .then(function (res) {
          setBusy(false);
          if (res.success) {
            BANNER_CONFIG.error.subtitle =
              'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.';
            showBanner('success');
            form.reset();
            resetTurnstile();
          } else {
            throw new Error(res.error || 'Unexpected response');
          }
        })
        .catch(function (err) {
          setBusy(false);
          BANNER_CONFIG.error.subtitle =
            'Your build request could not be submitted. Please try again in a moment or contact us directly.';
          showBanner('error');
          resetTurnstile();
          console.error('[TZ Personalised PC] Worker error:', err);
        });
    }

    /* ── DOM refs ── */
    var form = document.getElementById('tz_personalised_form');
    var firstNameEl = document.getElementById('tz_personalised_first_name');
    var lastNameEl = document.getElementById('tz_personalised_last_name');
    var emailEl = document.getElementById('tz_personalised_email');
    var phoneEl = document.getElementById('tz_personalised_phone');
    var countryEl = document.getElementById('tz_personalised_country');
    var messageEl = document.getElementById('tz_personalised_message');
    var submitBtn = document.getElementById('tz_personalised_submit_btn');
    var bannerSurface = document.getElementById('tz_p_banner_surface');
    var banner = document.getElementById('tz_p_banner');
    var bannerIconWrap = document.getElementById('tz_p_banner_icon_wrap');
    var bannerTag = document.getElementById('tz_p_banner_tag');
    var bannerTitle = document.getElementById('tz_p_banner_title');
    var bannerSubtitle = document.getElementById('tz_p_banner_subtitle');
    var bannerProgress = document.getElementById('tz_p_banner_progress');
    var bannerCloseBtn = banner ? banner.querySelector('.tz-p-banner-close-btn') : null;

    if (!form) return; /* snippet not on page – bail safely */

    /* ── SVG icons ── */
    var ICON_SUCCESS =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ICON_ERROR =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var ICON_INFO =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

    /* ── Banner content config per state ── */
    var BANNER_CONFIG = {
      success: {
        tagText: 'Build request received',
        title: 'Your dream PC build is in the works',
        subtitle:
          'Our experts are putting together a personalised setup for you. Expect a recommendation within 24 hours.',
        icon: ICON_SUCCESS,
        showProgress: true,
      },
      error: {
        tagText: 'Submission failed',
        title: 'Something went wrong \u2014 please try again.',
        subtitle:
          'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.',
        icon: ICON_ERROR,
        showProgress: false,
      },
      info: {
        tagText: 'Processing\u2026',
        title: 'Sending your build request',
        subtitle: 'Please hold on, this only takes a moment.',
        icon: ICON_INFO,
        showProgress: false,
      },
    };

    /* ── Show banner ── */
    function showBanner(type) {
      var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;

      banner.className = 'tz-p-banner tz-p-banner-' + type;
      bannerIconWrap.className = 'tz-p-banner-icon-wrap';
      bannerIconWrap.innerHTML = cfg.icon;
      bannerTag.className = 'tz-p-banner-tag';
      bannerTag.textContent = cfg.tagText;
      bannerTitle.textContent = cfg.title;
      bannerSubtitle.textContent = cfg.subtitle;

      if (cfg.showProgress) {
        bannerProgress.style.display = '';
        /* re-trigger animation cleanly */
        var fill = bannerProgress.querySelector('.tz-p-banner-progress-fill');
        var clone = fill.cloneNode(true);
        fill.parentNode.replaceChild(clone, fill);
        setTimeout(function () {
          banner.classList.add('tz-p-banner-animate');
        }, 20);
      } else {
        bannerProgress.style.display = 'none';
        banner.classList.remove('tz-p-banner-animate');
      }

      bannerSurface.classList.add('tz-p-banner-visible');
      bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ── Hide banner ── */
    function clearBanner() {
      bannerSurface.classList.remove('tz-p-banner-visible');
      banner.classList.remove('tz-p-banner-animate');
    }

    if (bannerCloseBtn) {
      bannerCloseBtn.addEventListener('click', clearBanner);
    }

    /* ── Button busy state ── */
    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitBtn.textContent = busy ? 'Please wait\u2026' : 'Get My Personalised PC Build';
    }

    /* ── Input error helpers ── */
    function markError(el) {
      el.classList.add('tz-p-input-error');
    }
    function clearErrors() {
      [firstNameEl, emailEl].forEach(function (el) {
        el.classList.remove('tz-p-input-error');
      });
    }

    /* ── Email format check ── */
    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
    }

    /* ── Client-side validation ── */
    function validate() {
      clearErrors();

      if (!firstNameEl.value.trim()) {
        markError(firstNameEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your first name so we can personalise your build recommendation.';
        showBanner('error');
        firstNameEl.focus();
        return false;
      }

      var email = emailEl.value.trim();
      if (!email) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your email address so we can send you the build recommendation.';
        showBanner('error');
        emailEl.focus();
        return false;
      }

      if (!isValidEmail(email)) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle =
          "That doesn't look like a valid email address. Please double-check and try again.";
        showBanner('error');
        emailEl.focus();
        return false;
      }

      /* ── Turnstile token check ── */
      var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
      if (!turnstileToken || !turnstileToken.value) {
        BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
        showBanner('error');
        return false;
      }

      return true;
    }

    /* ── Reset Turnstile widget ── */
    function resetTurnstile() {
      if (window.turnstile) {
        var widgetEl = document.getElementById('tz_personalised_turnstile');
        if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
          window.turnstile.reset(widgetEl._turnstileWidgetId);
        } else {
          window.turnstile.reset();
        }
      }
    }




    /* ── Live clear on user correction ── */
    firstNameEl.addEventListener('input', function () {
      firstNameEl.classList.remove('tz-p-input-error');
      clearBanner();
    });
    emailEl.addEventListener('input', function () {
      emailEl.classList.remove('tz-p-input-error');
      clearBanner();
    });

    /* ── Phone: strip any non-digit character on every input event ── */
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        var cleaned = phoneEl.value.replace(/\D/g, '');
        if (phoneEl.value !== cleaned) {
          /* preserve cursor position when characters are removed */
          var pos = phoneEl.selectionStart - (phoneEl.value.length - cleaned.length);
          phoneEl.value = cleaned;
          phoneEl.setSelectionRange(pos, pos);
        }
      });
    }

    form.addEventListener('submit', handleSubmit);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tz-join-creator-form"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ── Worker proxy URL ── */
  var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

  /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
  function submitToWorker(payload) {
    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    });
  }

  /* ── DOM refs ── */
  var jcrForm           = document.getElementById('tz-jcr-cta-form');
  var jcrNameEl         = document.getElementById('tz-jcr-cta-name');
  var jcrEmailEl        = document.getElementById('tz-jcr-cta-email');
  var jcrPhoneEl        = document.getElementById('tz-jcr-cta-phone');
  var jcrInstagramEl    = document.getElementById('tz-jcr-cta-instagram');
  var jcrYoutubeEl      = document.getElementById('tz-jcr-cta-youtube');
  var jcrTiktokEl       = document.getElementById('tz-jcr-cta-tiktok');
  var jcrSubmitBtn      = document.getElementById('tz-jcr-cta-submit');
  var jcrBannerSurface  = document.getElementById('tz_jcr_banner_surface');
  var jcrBanner         = document.getElementById('tz_jcr_banner');
  var jcrBannerIconWrap = document.getElementById('tz_jcr_banner_icon_wrap');
  var jcrBannerTag      = document.getElementById('tz_jcr_banner_tag');
  var jcrBannerTitle    = document.getElementById('tz_jcr_banner_title');
  var jcrBannerSubtitle = document.getElementById('tz_jcr_banner_subtitle');
  var jcrBannerProgress = document.getElementById('tz_jcr_banner_progress');
  var jcrBannerCloseBtn = jcrBanner ? jcrBanner.querySelector('.tz-banner-close-btn') : null;

  if (!jcrForm) return;

  /* ── SVG icons ── */
  var ICON_SUCCESS = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_ERROR   = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_INFO    = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

  /* ── Banner content config per type ── */
  var JCR_BANNER_CONFIG = {
    success: {
      tagText     : 'You\'re in the race!',
      title       : 'Thanks! You\'ve joined the Creator Race.',
      subtitle    : "We'll review your entry and be in touch soon. Get ready to race!",
      icon        : ICON_SUCCESS,
      showProgress: true
    },
    error: {
      tagText     : 'Entry failed',
      title       : 'Something went wrong \u2014 please try again.',
      subtitle    : 'Your Creator Race entry could not be sent. Check your details and try again, or contact us directly if the issue persists.',
      icon        : ICON_ERROR,
      showProgress: false
    },
    info: {
      tagText     : 'Entering the race\u2026',
      title       : 'Submitting your Creator Race entry',
      subtitle    : 'Please hold on, this only takes a moment.',
      icon        : ICON_INFO,
      showProgress: false
    }
  };

  /* ── Show banner ── */
  function jcrShowBanner(type) {
    var cfg = JCR_BANNER_CONFIG[type] || JCR_BANNER_CONFIG.info;
    jcrBanner.className           = 'tz-banner tz-banner-' + type;
    jcrBannerIconWrap.className   = 'tz-banner-icon-wrap';
    jcrBannerIconWrap.innerHTML   = cfg.icon;
    jcrBannerTag.className        = 'tz-banner-tag';
    jcrBannerTag.textContent      = cfg.tagText;
    jcrBannerTitle.textContent    = cfg.title;
    jcrBannerSubtitle.textContent = cfg.subtitle;
    if (cfg.showProgress) {
      jcrBannerProgress.style.display = '';
      var fill  = jcrBannerProgress.querySelector('.tz-banner-progress-fill');
      var clone = fill.cloneNode(true);
      fill.parentNode.replaceChild(clone, fill);
      setTimeout(function () { jcrBanner.classList.add('tz-banner-animate'); }, 20);
    } else {
      jcrBannerProgress.style.display = 'none';
      jcrBanner.classList.remove('tz-banner-animate');
    }
    jcrBannerSurface.classList.add('tz-banner-visible');
    jcrBannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ── Hide banner ── */
  function jcrClearBanner() {
    jcrBannerSurface.classList.remove('tz-banner-visible');
    jcrBanner.classList.remove('tz-banner-animate');
  }

  /* ── Dismiss on close button ── */
  if (jcrBannerCloseBtn) {
    jcrBannerCloseBtn.addEventListener('click', jcrClearBanner);
  }

  /* ── Button busy state ── */
  var jcrOriginalLabel = jcrSubmitBtn ? jcrSubmitBtn.textContent.trim() : '';
  function jcrSetBusy(busy) {
    jcrSubmitBtn.disabled    = busy;
    jcrSubmitBtn.textContent = busy ? 'Sending\u2026' : jcrOriginalLabel;
  }

  /* ── Input error helpers ── */
  function jcrMarkError(el) { el.classList.add('tz-input-error'); }
  function jcrClearErrors() {
    [jcrNameEl, jcrEmailEl, jcrPhoneEl, jcrInstagramEl, jcrYoutubeEl, jcrTiktokEl].forEach(function (el) {
      if (el) el.classList.remove('tz-input-error');
    });
  }

  /* ── Email format check ── */
  function jcrIsValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  }

  /* ── Client-side validation ── */
  function jcrValidate() {
    jcrClearErrors();

    if (!jcrNameEl.value.trim()) {
      jcrMarkError(jcrNameEl);
      JCR_BANNER_CONFIG.error.subtitle = 'Please enter your name.';
      jcrShowBanner('error');
      jcrNameEl.focus();
      return false;
    }

    var email = jcrEmailEl.value.trim();
    if (!email) {
      jcrMarkError(jcrEmailEl);
      JCR_BANNER_CONFIG.error.subtitle = 'Please enter your email address.';
      jcrShowBanner('error');
      jcrEmailEl.focus();
      return false;
    }

    if (!jcrIsValidEmail(email)) {
      jcrMarkError(jcrEmailEl);
      JCR_BANNER_CONFIG.error.subtitle = "That doesn\u2019t look like a valid email address. Please double-check and try again.";
      jcrShowBanner('error');
      jcrEmailEl.focus();
      return false;
    }

    /* ── Turnstile token check ── */
    var turnstileToken = jcrForm.querySelector('[name="cf-turnstile-response"]');
    if (!turnstileToken || !turnstileToken.value) {
      JCR_BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
      jcrShowBanner('error');
      return false;
    }

    return true;
  }

  /* ── Reset Turnstile widget ── */
  function jcrResetTurnstile() {
    if (window.turnstile) {
      var widgetEl = document.getElementById('tz-jcr-cta-turnstile');
      if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
        window.turnstile.reset(widgetEl._turnstileWidgetId);
      } else {
        window.turnstile.reset();
      }
    }
  }

  /* ── Main submit handler ── */
  function jcrHandleSubmit(e) {
    e.preventDefault();
    jcrClearBanner();

    if (!jcrValidate()) return;

    var name      = jcrNameEl.value.trim();
    var email     = jcrEmailEl.value.trim();
    var phone     = jcrPhoneEl     ? jcrPhoneEl.value.trim()     : '';
    var instagram = jcrInstagramEl ? jcrInstagramEl.value.trim() : '';
    var youtube   = jcrYoutubeEl   ? jcrYoutubeEl.value.trim()   : '';
    var tiktok    = jcrTiktokEl    ? jcrTiktokEl.value.trim()    : '';
    var turnstileTokenEl = jcrForm.querySelector('[name="cf-turnstile-response"]');
    var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';

    jcrSetBusy(true);
    jcrShowBanner('info');

    submitToWorker({
      email:          email,
      name:           name,
      tag:            'venoscorp-join-creator-race',
      subject:        'Join the Creator Race \u2013 ' + name,
      turnstileToken: turnstileToken,
      fields: [
        { label: 'Name',      value: name                       },
        { label: 'Email',     value: email                      },
        { label: 'Phone',     value: phone     || 'Not provided' },
        { label: 'Instagram', value: instagram || 'Not provided' },
        { label: 'YouTube',   value: youtube   || 'Not provided' },
        { label: 'TikTok',    value: tiktok    || 'Not provided' },
      ],
    })
      .then(function (res) {
        jcrSetBusy(false);
        if (res.success) {
          /* restore default error subtitle for next potential error */
          JCR_BANNER_CONFIG.error.subtitle = 'Your Creator Race entry could not be sent. Check your details and try again, or contact us directly if the issue persists.';
          jcrShowBanner('success');
          jcrForm.reset();
          jcrResetTurnstile();
        } else {
          throw new Error(res.error || 'Unexpected response');
        }
      })
      .catch(function (err) {
        jcrSetBusy(false);
        JCR_BANNER_CONFIG.error.subtitle = 'Your Creator Race entry could not be submitted. Please try again in a moment or contact us directly.';
        jcrShowBanner('error');
        jcrResetTurnstile();
        console.error('[TZ Join Creator Race] Worker error:', err);
      });
  }

  /* ── Live clear on user correction ── */
  [jcrNameEl, jcrEmailEl, jcrInstagramEl, jcrYoutubeEl, jcrTiktokEl].forEach(function (el) {
    if (el) el.addEventListener('input', function () {
      el.classList.remove('tz-input-error');
      jcrClearBanner();
    });
  });

  /* ── Phone: digits only + live clear ── */
  if (jcrPhoneEl) {
    jcrPhoneEl.addEventListener('input', function () {
      jcrPhoneEl.classList.remove('tz-input-error');
      jcrClearBanner();
      var cleaned = jcrPhoneEl.value.replace(/\D/g, '');
      if (jcrPhoneEl.value !== cleaned) {
        var pos = jcrPhoneEl.selectionStart - (jcrPhoneEl.value.length - cleaned.length);
        jcrPhoneEl.value = cleaned;
        jcrPhoneEl.setSelectionRange(pos, pos);
      }
    });
  }

  jcrForm.addEventListener('submit', jcrHandleSubmit);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tz-need-help-choosing-the-right-pc"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* ── Worker proxy URL ── */
    var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

    /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
    function submitToWorker(payload) {
      return fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
          return data;
        });
      });
    }

    /* ── DOM refs ── */
    var form = document.getElementById('tz_nhc_form');
    var nameEl = document.getElementById('tz_nhc_name');
    var phoneEl = document.getElementById('tz_nhc_phone');
    var countryEl = document.getElementById('tz_nhc_country');
    var submitBtn = document.getElementById('tz_nhc_submit_btn');
    var bannerSurface = document.getElementById('tz_nhc_banner_surface');
    var banner = document.getElementById('tz_nhc_banner');
    var bannerIconWrap = document.getElementById('tz_nhc_banner_icon_wrap');
    var bannerTag = document.getElementById('tz_nhc_banner_tag');
    var bannerTitle = document.getElementById('tz_nhc_banner_title');
    var bannerSubtitle = document.getElementById('tz_nhc_banner_subtitle');
    var bannerProgress = document.getElementById('tz_nhc_banner_progress');
    var bannerCloseBtn = banner ? banner.querySelector('.tz-nhc-banner-close-btn') : null;

    if (!form) return;

    /* ── SVG icons ── */
    var ICON_SUCCESS =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ICON_ERROR =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var ICON_INFO =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

    /* ── Banner config ── */
    var BANNER_CONFIG = {
      success: {
        tagText: 'Request received',
        title: "We'll call you back shortly!",
        subtitle:
          'One of our PC experts will be in touch to help you find the perfect setup. We typically respond within a few hours during business hours.',
        icon: ICON_SUCCESS,
        showProgress: true,
      },
      error: {
        tagText: 'Submission failed',
        title: 'Something went wrong \u2014 please try again.',
        subtitle:
          'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.',
        icon: ICON_ERROR,
        showProgress: false,
      },
      info: {
        tagText: 'Processing\u2026',
        title: 'Sending your call-back request',
        subtitle: 'Please hold on, this only takes a moment.',
        icon: ICON_INFO,
        showProgress: false,
      },
    };

    /* ── Show banner ── */
    function showBanner(type) {
      var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;

      banner.className = 'tz-nhc-banner tz-nhc-banner-' + type;
      bannerIconWrap.className = 'tz-nhc-banner-icon-wrap';
      bannerIconWrap.innerHTML = cfg.icon;
      bannerTag.className = 'tz-nhc-banner-tag';
      bannerTag.textContent = cfg.tagText;
      bannerTitle.textContent = cfg.title;
      bannerSubtitle.textContent = cfg.subtitle;

      if (cfg.showProgress) {
        bannerProgress.style.display = '';
        var fill = bannerProgress.querySelector('.tz-nhc-banner-progress-fill');
        var clone = fill.cloneNode(true);
        fill.parentNode.replaceChild(clone, fill);
        setTimeout(function () {
          banner.classList.add('tz-nhc-banner-animate');
        }, 20);
      } else {
        bannerProgress.style.display = 'none';
        banner.classList.remove('tz-nhc-banner-animate');
      }

      bannerSurface.classList.add('tz-nhc-banner-visible');
      bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ── Hide banner ── */
    function clearBanner() {
      bannerSurface.classList.remove('tz-nhc-banner-visible');
      banner.classList.remove('tz-nhc-banner-animate');
    }

    if (bannerCloseBtn) {
      bannerCloseBtn.addEventListener('click', clearBanner);
    }

    /* ── Button busy state ── */
    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitBtn.textContent = busy ? 'Please wait\u2026' : 'REQUEST A CALL BACK';
    }

    /* ── Input error helpers ── */
    function markError(el) {
      el.classList.add('tz-nhc-input-error');
    }
    function clearErrors() {
      nameEl.classList.remove('tz-nhc-input-error');
      if (phoneEl) phoneEl.classList.remove('tz-nhc-input-error');
    }

    /* ── Validation ── */
    function validate() {
      clearErrors();

      if (!nameEl.value.trim()) {
        markError(nameEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your name so our team knows who to call back.';
        showBanner('error');
        nameEl.focus();
        return false;
      }

      if (phoneEl && !phoneEl.value.trim()) {
        markError(phoneEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your phone number so we can call you back.';
        showBanner('error');
        phoneEl.focus();
        return false;
      }

      /* ── Turnstile token check ── */
      var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
      if (!turnstileToken || !turnstileToken.value) {
        BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
        showBanner('error');
        return false;
      }

      return true;
    }

    /* ── Reset Turnstile widget ── */
    function resetTurnstile() {
      if (window.turnstile) {
        var widgetEl = document.getElementById('tz_nhc_turnstile');
        if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
          window.turnstile.reset(widgetEl._turnstileWidgetId);
        } else {
          window.turnstile.reset();
        }
      }
    }

    /* ── Main submit handler ── */
    function handleSubmit(e) {
      e.preventDefault();
      clearBanner();

      if (!validate()) return;

      var name = nameEl.value.trim();
      var dialCode = countryEl ? countryEl.value : '';
      var phone = phoneEl ? phoneEl.value.trim() : '';
      var fullPhone = dialCode && phone ? dialCode + ' ' + phone : phone || 'Not provided';
      var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';

      /* Generate a placeholder email since this form doesn't ask for one */
      var slug = name
        .toLowerCase()
        .replace(/\s+/g, '.')
        .replace(/[^a-z0-9.]/g, '');
      var email = slug + '@callbackrequest.venoscorp.internal';

      setBusy(true);
      showBanner('info');

      submitToWorker({
        email:          email,
        name:           name,
        tag:            'need-help-choosing-the-right-pc',
        subject:        'PC Advice Call-Back \u2013 ' + name,
        turnstileToken: turnstileToken,
        fields: [
          { label: 'Name',  value: name      },
          { label: 'Phone', value: fullPhone },
        ],
      })
        .then(function (res) {
          setBusy(false);
          if (res.success) {
            BANNER_CONFIG.error.subtitle =
              'Your request could not be sent. Check your details and try again, or contact us directly if the issue persists.';
            showBanner('success');
            form.reset();
            resetTurnstile();
          } else {
            throw new Error(res.error || 'Unexpected response');
          }
        })
        .catch(function (err) {
          setBusy(false);
          BANNER_CONFIG.error.subtitle =
            'The call-back request could not be submitted. Please try again or contact us directly.';
          showBanner('error');
          resetTurnstile();
          console.error('[TZ NHC] Worker error:', err);
        });
    }

    /* ── Live clear on user correction ── */
    nameEl.addEventListener('input', function () {
      nameEl.classList.remove('tz-nhc-input-error');
      clearBanner();
    });
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        phoneEl.classList.remove('tz-nhc-input-error');
        clearBanner();
      });
    }

    /* ── Phone: digits only ── */
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        var cleaned = phoneEl.value.replace(/\D/g, '');
        if (phoneEl.value !== cleaned) {
          var pos = phoneEl.selectionStart - (phoneEl.value.length - cleaned.length);
          phoneEl.value = cleaned;
          phoneEl.setSelectionRange(pos, pos);
        }
      });
    }

    form.addEventListener('submit', handleSubmit);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tz-newsletter-form"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ── Worker proxy URL ── */
  var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

  /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
  function submitToWorker(payload) {
    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
        return data;
      });
    });
  }

  /* ── Main submit handler ── */
  function handleSubmit(e) {
    e.preventDefault();
    clearBanner();

    if (!validate()) return;

    var email = emailEl.value.trim();
    var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
    var turnstileToken   = turnstileTokenEl ? turnstileTokenEl.value : '';
    setBusy(true);
    showBanner('info');

    submitToWorker({
      email:           email,
      name:            email.split('@')[0],
      tag:             'newsletter-form',
      subject:         'Newsletter Subscription \u2013 ' + email,
      turnstileToken:  turnstileToken,
      fields: [
        { label: 'Email', value: email },
        { label: 'Type',  value: 'Newsletter subscription' },
      ],
    })
      .then(function (res) {
        setBusy(false);
        if (res.success) {
          BANNER_CONFIG.error.subtitle = 'Your subscription could not be completed. Check your details and try again, or contact us directly if the issue persists.';
          showBanner('success');
          form.reset();
          resetTurnstile();
        } else {
          throw new Error(res.error || 'Unexpected response');
        }
      })
      .catch(function (err) {
        setBusy(false);
        BANNER_CONFIG.error.subtitle = 'Your subscription could not be completed. Please try again in a moment or contact us directly.';
        showBanner('error');
        resetTurnstile();
        console.error('[TZ Newsletter] Worker error:', err);
      });
  }

  /* ── DOM refs ── */
  var form          = document.getElementById('tz_newsletter_form');
  var emailEl       = document.getElementById('tz_email_input');
  var consentEl     = document.getElementById('tz_consent_checkbox');
  var submitBtn     = document.getElementById('tz_submit_btn');
  var bannerSurface = document.getElementById('tz_newsletter_banner_surface');
  var banner        = document.getElementById('tz_newsletter_banner');
  var bannerIconWrap= document.getElementById('tz_banner_icon_wrap');
  var bannerTag     = document.getElementById('tz_banner_tag');
  var bannerTitle   = document.getElementById('tz_banner_title');
  var bannerSubtitle= document.getElementById('tz_banner_subtitle');
  var bannerProgress= document.getElementById('tz_banner_progress');
  var bannerCloseBtn= banner ? banner.querySelector('.tz-banner-close-btn') : null;

  if (!form) return; /* snippet not on page – bail safely */

  /* ── SVG icons ── */
  var ICON_SUCCESS = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_ERROR   = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_INFO    = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

  /* ── Banner content config per type ── */
  var BANNER_CONFIG = {
    success: {
      tagText   : 'Subscription confirmed',
      title     : "You're in! Welcome to the VenoScorp community.",
      subtitle  : 'Exclusive deals, build drops, and gaming news are on their way to your inbox.',
      icon      : ICON_SUCCESS,
      showProgress: true
    },
    error: {
      tagText   : 'Submission failed',
      title     : "Something went wrong — please try again.",
      subtitle  : 'Your subscription could not be completed. Check your details and try again, or contact us directly if the issue persists.',
      icon      : ICON_ERROR,
      showProgress: false
    },
    info: {
      tagText   : 'Processing…',
      title     : 'Sending your subscription request',
      subtitle  : 'Please hold on, this only takes a moment.',
      icon      : ICON_INFO,
      showProgress: false
    }
  };

  /* ── Show banner ── */
  function showBanner(type) {
    var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;

    /* reset banner state classes */
    banner.className = 'tz-banner tz-banner-' + type;

    /* icon wrap class */
    bannerIconWrap.className = 'tz-banner-icon-wrap';
    bannerIconWrap.innerHTML = cfg.icon;

    /* texts */
    bannerTag.className      = 'tz-banner-tag';
    bannerTag.textContent    = cfg.tagText;
    bannerTitle.textContent  = cfg.title;
    bannerSubtitle.textContent = cfg.subtitle;

    /* progress bar */
    if (cfg.showProgress) {
      bannerProgress.style.display = '';
      /* re-trigger animation by cloning the fill element */
      var fill = bannerProgress.querySelector('.tz-banner-progress-fill');
      var clone = fill.cloneNode(true);
      fill.parentNode.replaceChild(clone, fill);
      /* mark as animate after a tick so CSS animation fires */
      setTimeout(function () { banner.classList.add('tz-banner-animate'); }, 20);
    } else {
      bannerProgress.style.display = 'none';
      banner.classList.remove('tz-banner-animate');
    }

    /* show surface */
    bannerSurface.classList.add('tz-banner-visible');
    bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ── Hide banner ── */
  function clearBanner() {
    bannerSurface.classList.remove('tz-banner-visible');
    banner.classList.remove('tz-banner-animate');
  }

  /* ── Dismiss on close button ── */
  if (bannerCloseBtn) {
    bannerCloseBtn.addEventListener('click', clearBanner);
  }

  /* ── Button busy state ── */
  function setBusy(busy) {
    submitBtn.disabled = busy;
    submitBtn.textContent = busy ? 'Please wait\u2026' : 'Subscribe & Save';
  }

  /* ── Input error helpers ── */
  function markError(el) { el.classList.add('tz-input-error'); }
  function clearErrors() {
    emailEl.classList.remove('tz-input-error');
    consentEl.classList.remove('tz-input-error');
  }

  /* ── Email format check ── */
  function isValidEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  }

  /* ── Client-side validation ── */
  function validate() {
    clearErrors();
    var email = emailEl.value.trim();

    if (!email) {
      markError(emailEl);
      BANNER_CONFIG.error.subtitle = 'Please enter your email address to continue.';
      showBanner('error');
      emailEl.focus();
      return false;
    }

    if (!isValidEmail(email)) {
      markError(emailEl);
      BANNER_CONFIG.error.subtitle = "That doesn't look like a valid email address. Please double-check and try again.";
      showBanner('error');
      emailEl.focus();
      return false;
    }

    if (!consentEl.checked) {
      markError(consentEl);
      BANNER_CONFIG.error.subtitle = 'You must agree to our Privacy Policy and Terms & Conditions before subscribing.';
      showBanner('error');
      consentEl.focus();
      return false;
    }

    /* ── Turnstile token check ── */
    var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
    if (!turnstileToken || !turnstileToken.value) {
      BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before subscribing.';
      showBanner('error');
      return false;
    }

    return true;
  }

  /* ── Reset Turnstile widget ── */
  function resetTurnstile() {
    if (window.turnstile) {
      var widgetEl = document.getElementById('tz_newsletter_turnstile');
      if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
        window.turnstile.reset(widgetEl._turnstileWidgetId);
      } else {
        window.turnstile.reset();
      }
    }
  }



  /* ── Live clear on user correction ── */
  emailEl.addEventListener('input', function () {
    emailEl.classList.remove('tz-input-error');
    clearBanner();
  });
  consentEl.addEventListener('change', function () {
    consentEl.classList.remove('tz-input-error');
    clearBanner();
  });

  form.addEventListener('submit', handleSubmit);
})();
  } catch(e) { console.error(e); }
})();

})();
